"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuestRoute = GuestRoute;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function GuestRoute(_ref) {
  let {
    currentUser,
    defaultPrivatePath,
    children
  } = _ref;
  if (currentUser) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
    to: {
      pathname: defaultPrivatePath
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
}